import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-display-only-icon',
  templateUrl: './display-only-icon.component.html',
  styleUrls: ['./display-only-icon.component.scss'],
  standalone: false,
})
export class DisplayOnlyIconComponent {
  @Input() icon!: string | undefined;
  @Input() route!: string | undefined;
  @Input() displayText = '';
  @Input() hasDisplayText = false;
  @Output() emitClick = new EventEmitter();

  constructor(public router: Router) {}

  get isActive() {
    return this.router.url.includes(this.route as string);
  }

  handleClick() {
    this.emitClick.emit('');
  }
}
